export const REQUEST_INQUIRY_LIST = "REQUEST_INQUIRY_LIST"
export const REQUEST_INQUIRY = "REQUEST_INQUIRY"